
// @ts-nocheck
import locale_es_45ES_46json_a24145ab from "#nuxt-i18n/a24145ab";
import locale_es_45ES_46json_4ab31abd from "#nuxt-i18n/4ab31abd";

export const localeCodes =  [
  "es-ES"
]

export const localeLoaders = {
  "es-ES": [
    {
      key: "locale_es_45ES_46json_a24145ab",
      load: () => Promise.resolve(locale_es_45ES_46json_a24145ab),
      cache: true
    },
    {
      key: "locale_es_45ES_46json_4ab31abd",
      load: () => Promise.resolve(locale_es_45ES_46json_4ab31abd),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/58ce4d43" /* webpackChunkName: "config_i18n_46options_46ts_58ce4d43" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "es-ES",
      domain: "https://www.escapadarural.com",
      language: "es-ES",
      isCatchallLocale: true,
      files: [
        {
          path: "/builds/escapadarural/rurality-nuxt/node_modules/nuxt-zod-i18n/dist/runtime/locales/es-ES.json",
          cache: undefined
        },
        {
          path: "/builds/escapadarural/rurality-nuxt/i18n/locales/es-ES.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "es-ES",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: [
    {
      langDir: "/builds/escapadarural/rurality-nuxt/node_modules/nuxt-zod-i18n/dist/runtime/locales",
      locales: [
        {
          code: "es-ES"
        }
      ]
    }
  ]
}

export const normalizedLocales = [
  {
    code: "es-ES",
    domain: "https://www.escapadarural.com",
    language: "es-ES",
    isCatchallLocale: true,
    files: [
      {
        path: "/builds/escapadarural/rurality-nuxt/node_modules/nuxt-zod-i18n/dist/runtime/locales/es-ES.json",
        cache: undefined
      },
      {
        path: "/builds/escapadarural/rurality-nuxt/i18n/locales/es-ES.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/